import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import {
  COMBOBOX_TRIGGER_ICON,
  type TComboboxTriggerElement,
  type TComboboxTriggerProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const ComboboxTrigger = forwardRef<TComboboxTriggerElement, TComboboxTriggerProps>(
  (
    {
      className,
      error,
      placeholder,
      selectedLabel,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Trigger
      data-component="ComboboxTrigger"
      data-placeholder={selectedLabel ? undefined : ""}
      ref={ref}
      aria-invalid={!!error}
      className={cn(
        "peer",
        "flex w-full box-border items-center justify-between gap-2 rounded-sys-sm border border-solid border-component-input-default bg-component-input-focused data-[placeholder]:bg-component-input-default shadow-sm p-2",
        "overflow-hidden",
        "disabled:text-foreground-muted disabled:cursor-not-allowed",
        "font-sys-default",
        "focus:outline focus:outline-1 focus:outline-offset-0 focus:outline-sys-black focus:ring-4 focus:ring-focus-primary focus:bg-component-input-focused",
        error && "border-component-input-destructive focus:ring-focus-destructive focus:outline-transparent",
        className,
      )}
      {...props}
    >
      <TextBody
        tag="span"
        size={2}
        isResponsive={false}
        className={cn(
          "block min-w-0 truncate",
          !selectedLabel && "text-foreground-muted",
        )}
      >
        { selectedLabel ?? placeholder }
      </TextBody>
      <Icon
        icon={COMBOBOX_TRIGGER_ICON}
        aria-hidden="true"
        size="sm"
        className="shrink-0 opacity-50"
      />
    </PopoverPrimitive.Trigger>
  ),
);

ComboboxTrigger.displayName = PopoverPrimitive.Trigger.displayName;
